import { EventEmitter, inject, Injectable, InjectionToken, WritableSignal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CathyService } from '@sbd-doug-frontend/app/services/cathy.service';

export const QUOTE_REQUESTS_LIST_SERVICE_TOKEN = new InjectionToken<AbstractQuoteRequestsListService>('QUOTE_REQUESTS_LIST_SERVICE_TOKEN');

@Injectable()
export abstract class AbstractQuoteRequestsListService {
  _httpClient = inject(HttpClient);
  _cathyService = inject(CathyService);

  abstract totalQuoteRequests: WritableSignal<number>;
  abstract quoteRequests: WritableSignal<any[]>;
  abstract notFilterableFields: WritableSignal<string[]>;
  abstract triggerRefresh: EventEmitter<void>;
  abstract isLoading: WritableSignal<boolean>;

  abstract getQuoteRequestsList(filters?: any): Observable<any[]>;
  abstract loadQuoteRequest(quoteRequestId: number, accountId: number ): Observable<any>;
}
